import { QueryType, } from '../types/index.js';
export const In = (value) => ({
    _type: QueryType.In,
    value,
});
export const isInQuery = (value) => {
    return (typeof value === 'object' &&
        value._type === QueryType.In);
};
export const applyQuery = (object, filter) => {
    return Object.keys(filter).every((key) => {
        const filterValue = filter[key];
        if (isInQuery(filterValue)) {
            return filterValue.value.includes(object[key]);
        }
        return filter[key] === object[key];
    });
};
//# sourceMappingURL=query.utils.js.map